
import "/app/src/modules/zy-crm/components/drawer-assist-panel/style.module.less?modules";
export default {"sectionTitle": `sectionTitle-7BrRSdbI`,"stamp": `stamp-I-iOqbvT`,"list": `list-86Y4MUDk`,"frame": `frame-s249JQ-5`,"head": `head-1ib4tkxa`,"title": `title-qCOIRVpL`,"empty": `empty-yNNPkRTg`,"overview": `overview-8UvNlA5z`}
